import React from 'react';
import { CircularProgress } from '@material-ui/core';

import { makeStyles } from '@material-ui/styles';
import styles from './styles';
import classNames from 'classnames';
import { muiTheme } from '../../../theme';
import Typography from '@material-ui/core/Typography';

const Loader = ({ error, containerClass, opacity = false, width = '100%', loadingMessage = '', ...props }) => {
  const classes = makeStyles(styles(muiTheme))();
  return (
    <div
      className={classNames(containerClass ? containerClass : classes.root, { [classes.opacity]: opacity })}
      style={{ width }}
    >
      <CircularProgress disableShrink error={error ? error.toString() : ''} {...props} />
      {loadingMessage && <Typography>{loadingMessage}</Typography>}
    </div>
  );
};

const LoadingIndicator = props => <Loader {...props}></Loader>;

export default LoadingIndicator;
